// extracted by mini-css-extract-plugin
export default {"container":"zA-z","modal":"AA-z","dimensions":"BA-z","brandName":"CA-z","productName":"DA-z","labelValue":"EA-z","recipientEmail":"FA-z","recommendedFit":"GA-z","hiddenField":"HA-z"};